import { InjectedFormProps, reduxForm } from "redux-form";

import { Button, Separator, Wrapper } from "src/styled";
import { TextArea, TypedField } from "src/components";
import { translate } from "src/services";

export const ADD_NOTE_FORM_NAME = "addNoteForm";

interface PropsWithoutReduxForm {}

export interface AddNoteFormValues {
  note: string;
}

type Props = PropsWithoutReduxForm & InjectedFormProps<AddNoteFormValues, PropsWithoutReduxForm>;

const AddNoteForm = ({ handleSubmit, initialValues }: Props) => {
  return (
    <form onSubmit={handleSubmit}>
      <Wrapper padding="0 50px" maxWidth={500} margin="no auto">
        <Separator height={100} />

        <TypedField
          component={TextArea}
          name="note"
          props={{
            margin: "no auto",
            placeholder: translate("wizardPage.addNote"),
          }}
        />

        <Separator height={150} />
        <Wrapper margin="no auto" textAlign="center">
          <Button
            type="button"
            color="primary"
            size="medium"
            borderRadius="100px"
            onClick={handleSubmit}
          >
            {initialValues?.note
              ? translate("wizardPage.saveNote")
              : translate("wizardPage.addNote")}
          </Button>
        </Wrapper>
      </Wrapper>
    </form>
  );
};

export default reduxForm<AddNoteFormValues, PropsWithoutReduxForm>({
  form: ADD_NOTE_FORM_NAME,
  enableReinitialize: true,
})(AddNoteForm);
